import type { StatusBadgeTone } from './StatusBadgeTone';

const BASE =
  'inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-medium ring-1 ring-inset';

const TONE: Record<StatusBadgeTone, string> = {
  neutral: 'bg-secondary-50 text-secondary-700 ring-secondary-200',
  info: 'bg-primary-50 text-primary-800 ring-primary-100',
  caution: 'bg-amber-50 text-amber-900 ring-amber-200',
  danger: 'bg-red-50 text-red-800 ring-red-100',
  success: 'bg-emerald-50 text-emerald-800 ring-emerald-100',
};

export function statusBadgeClass(tone: StatusBadgeTone = 'neutral'): string {
  return `${BASE} ${TONE[tone]}`;
}

/** Mapeia códigos de status comuns do ERP para o tom do badge. */
export function resolveStatusTone(status: string): StatusBadgeTone {
  const key = status.trim().toLowerCase().replace(/[\s_-]/g, '');

  switch (key) {
    case 'active':
    case 'ativa':
    case 'ativo':
    case 'open':
    case 'aberto':
    case 'completed':
    case 'concluida':
    case 'concluido':
    case 'resolved':
    case 'resolvido':
    case 'processed':
    case 'processado':
    case 'accepted':
    case 'aceita':
    case 'achieved':
    case 'sent':
    case 'enviada':
    case 'closed':
    case 'encerrado':
    case 'fechado':
    case 'done':
    case 'enabled':
      return 'success';

    case 'inprogress':
    case 'emandamento':
    case 'processing':
    case 'processando':
    case 'investigating':
    case 'investigando':
    case 'underreview':
    case 'triaged':
    case 'ematendimento':
      return 'info';

    case 'suspended':
    case 'suspenso':
    case 'onhold':
    case 'emespera':
    case 'paused':
    case 'pausada':
    case 'overdue':
    case 'atrasada':
    case 'pendingcustomer':
    case 'aguardandocliente':
    case 'knownerror':
    case 'erroconhecido':
    case 'warning':
    case 'awaitingclient':
    case 'reopened':
    case 'reaberto':
    case 'deprecated':
    case 'depreciada':
      return 'caution';

    case 'cancelled':
    case 'canceled':
    case 'cancelado':
    case 'cancelada':
    case 'failed':
    case 'falhou':
    case 'expired':
    case 'expirado':
    case 'rejected':
    case 'recusada':
    case 'inactive':
    case 'inativa':
    case 'inativo':
    case 'lost':
    case 'missed':
    case 'notachieved':
    case 'retired':
    case 'descontinuada':
    case 'archived':
    case 'arquivada':
      return 'danger';

    case 'draft':
    case 'rascunho':
    case 'pending':
    case 'pendente':
    case 'planned':
    case 'planejada':
    case 'new':
    case 'novo':
    case 'ignored':
    case 'ignorado':
    case 'skipped':
    default:
      return 'neutral';
  }
}
